module.exports = __webpack_public_path__ + "static/media/Moldova.4961540b.png";